import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[appTypeheadInputTagTmp]',
    standalone: true,
})
export class NgTypeheadInputTagTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}

@Directive({
    selector: '[appTypeheadInputOptionTmp]',
    standalone: true,
})
export class NgTypeheadInputOptionTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}

@Directive({
    selector: '[appTypeheadInputOptionGroupTmp]',
    standalone: true,
})
export class NgTypeheadInputOptionGroupTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}

@Directive({
    selector: '[appSelectInputOptionTmp]',
    standalone: true,
})
export class NgSelectInputOptionTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}

@Directive({
    selector: '[appSelectInputLabelTmp]',
    standalone: true,
})
export class NgSelectInputLabelTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}
